<div [ngSwitch]="filterType">
  <div *ngSwitchCase="'radio-buttons'" [ngStyle]="{'margin-bottom': dynamicClass ==='report-section'?'8px':'0px'}">
    <div class="radio-box">
      <div class="d-flex" [ngClass]="dynamicClass">
        <ng-container *ngFor="let filter of filters">
          <div class="d-flex" [ngClass]="dynamicGap">
            <input
              class="radio-option"
              type="radio"
              [name]="filter.name"
              [id]="filter.id"
              [(ngModel)]="selectedFilter"
              (click)="fnOnFilterChange('radio-filter', filter.value)"
              [value]="filter.value"
            />
            <label class="radio-option" [for]="filter.id" [ngStyle]="{'color': dynamicLabelColor ? dynamicLabelColor : '#000'}">{{ filter.label }}</label>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'custom-search-dropdown'">
    <div class="filter">
      <div class="form-group mb-0">
        <app-search-dropdown
          [(ngModel)]="placeholder"
          [items]="filters"
          [size]="size"
          [uid]="searchId"
          [label]="searchDisplay"
          [placeholder]="placeholder"
          [componentName]="componentName"
          (afterChange)="fnOnFilterChange('custom-search-dropdown', $event)"
        ></app-search-dropdown>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'select-dropdown'">
    <div class="form-group mb-0">
      <select
        [title]="titleName"
        class="form-select"
        [class]="className"
        [(ngModel)]="selectedOptionDropdown"
        name="selectedOption"
        (ngModelChange)="fnOnFilterChange('select-dropdown', $event)"
      >
        <option *ngFor="let filter of filters" [ngValue]="filter.value">
          {{ filter.label }}
        </option>
      </select>
    </div>
  </div>
</div>
